import { Component, Input, OnInit } from '@angular/core';
import { CmsComponent } from '@kion/data-models';
import { Observable } from 'rxjs';
import { CmsComponentsFacade } from '@kion/data-access/data-access-cms-components';
import { CmsConfig } from '../../config/cms.config';
import { map } from 'rxjs/operators';

interface Block {
  title: string;
  description?: string;
  icon?: string;
  stepNumber?: number;
  completed?: boolean;
}

@Component({
  selector: 'kion-cms-next-step',
  templateUrl: './next-step.component.html',
  styleUrls: ['./next-step.component.scss']
})
export class NextStepComponent implements OnInit {

  @Input() component: CmsComponent;

  components$: Observable<Block[]>;

  constructor(private cmsComponentsFacade: CmsComponentsFacade, private cmsConfig: CmsConfig) { }

  ngOnInit(): void {
    const components = this.component?.subComponents?.split(' ') || [];
    this.cmsComponentsFacade.loadByIds(components);
    this.components$ = this.cmsComponentsFacade.all$.pipe(
      map(
        (cmsComponents: CmsComponent[]) => cmsComponents.filter(
          cmsComponent => !!components.find(component => component === cmsComponent.uid)
        ).sort((a,b) => components.indexOf(a.uid) > components.indexOf(b.uid) ? 1 : -1).map(
          (component: CmsComponent, i: number) => {
            const block: Block = {
              title: component.title
            };

            if (component.nextIcon === 'numeric') {
              block.stepNumber = i + 1;
            } else if (component.nextIcon) {
              block.icon = './assets/banner-icons/' + component.nextIcon + '.svg';
            }

            if (component.content) {
              block.description = component.content;
            }
            return block;
          }
        ).map(
          (block, index) => {
            if (index === 0){
              if (this.component.typeCode !== 'KionUspComponent') {
                return {
                  ...block,
                  completed: true
                };
              }
              return block;
            }
            return block;
          }
        )
      )
    );
  }
}
